<!-- Valderane, 30/03/2025 -->
<div *ngIf="vehicule !=null && vehicule !=undefined">
    <div>
        <ng-image-slider 
            [images]="imageVehicule"
            [infinite]="false"
            [autoSlide]="1"
            [imageSize]="{width:'500px',height:'500px'}"
            slideImage="1"
            #nav>
        </ng-image-slider>
    </div>
   
    <mat-card>
        <mat-card-content>
            <div class="flex-container">
                <div class="flex-item-left br">
                    <p>
                        <span class="title">{{vehicule.otherCaracteristique.vehicle_mark}} {{vehicule.otherCaracteristique.vehicle_model}}</span> <br>
                        <span class="subtitle">{{vehicule.otherCaracteristique.vehicle_gearboxe}},{{vehicule.otherCaracteristique.vehicle_energie}},{{vehicule.otherCaracteristique.vehicle_value}}</span>
                    </p>
                    <p>
                        <span class="label-text">Propriétaire :</span>
                        <span class="text-value">{{vehicule.otherCaracteristique.user_name}} {{vehicule.otherCaracteristique.user_surname}}</span>
                    </p>
                    <p>
                        <span class="label-text">Immatriculation :</span>
                        <span class="text-value">{{vehicule.otherCaracteristique.vehicle_registration}}</span>
                    </p>
                    <p>
                        <mat-icon color="primary">location_on</mat-icon> <span style="margin-left:5px">{{vehicule.otherCaracteristique.vehicle_adress}}</span>
                    </p>
                   
                </div>
                <div class="flex-item-right">
                    <div class="flex-container location-dispo">
                        <div class="flex-item-left location-amount">
                            <mat-icon>payments</mat-icon><span class="title" style="margin:5px"> {{vehicule.otherCaracteristique.vehicle_price_location}} XAF</span><br>
                            <span class="subtitle">Location</span>                         
                        </div>
                        <div class="flex-item-right diponibility-car">
                            <p>
                                 <mat-icon color="primary" *ngIf="vehicule.otherCaracteristique.status=='disponible'">check_circle</mat-icon>
                                 <mat-icon color="primary"  *ngIf="vehicule.otherCaracteristique.status=='indisponible'">do_not_disturb_on</mat-icon>
                                 <span class="title" [ngStyle]="{'color':(vehicule.otherCaracteristique.status=='disponible')?'#1565c0':'#ff5252','margin':'5px'}" >{{vehicule.otherCaracteristique.status}}</span>
                                 <br>
                                 <span class="subtitle">Depuis le {{vehicule.otherCaracteristique.created_at | date: "mediumDate"}}</span>
                            </p>
                        </div>
                    </div>
                    <div class="flex-container location-dispo">
                        <div class="flex-item-left">
                            <p>
                                <mat-icon style="color: #1db91d !important;margin:5px">verified_user</mat-icon><span class="title">{{vehicule.otherCaracteristique.vehicle_number_insurance}}</span><br>
                                <span class="subtitle">Numero d'assurance</span>                        
                            </p>
                        </div>
                        <div class="flex-item-right">
                            <p>
                                <mat-icon style="color: red !important;margin:5px">drive_eta</mat-icon><span class="title">
                                    {{vehicule.otherCaracteristique.vehicle_driver == 1 ? 'Avec' : 'Sans'}}
                                </span><br>
                                <span class="subtitle">Chauffeur</span>                        
                            </p>
                        </div>                   
                    </div>
                </div>
            </div>
        </mat-card-content>
        <mat-card-actions align="end">
            <button mat-flat-button (click)="list()"matTooltip="Liste  des véhicules">
                <mat-icon class="mat-18" style="font-size: 19px;" color="primary">format_list_bulleted</mat-icon>Liste
            </button>
            <!-- <button (click)="updateFileImage()" mat-flat-button matTooltip="Changer les photos du véhicule">
                <mat-icon class="mat-18" style="font-size: 19px;" color="primary">add_a_photo</mat-icon>Modifier Image
            </button> -->
            <button mat-flat-button (click)="edit()" matTooltip="Modifier les informations du véhicule">
                <mat-icon class="mat-18" style="font-size: 19px;" color="primary">edit</mat-icon>Modifier Info
            </button>
            <button mat-flat-button (click)="remove()" matTooltip="Supprimer le véhicule">
                <mat-icon class="mat-18" style="font-size: 19px;" color="warn" >delete_outline</mat-icon>Supprimer
            </button>
               
                 
        </mat-card-actions>
    </mat-card>
    
    <mat-accordion >
        <mat-expansion-panel style="margin-top:10px">
            <mat-expansion-panel-header>
            <mat-panel-title>
                Caractéristiques du vehicule
            </mat-panel-title>
            </mat-expansion-panel-header>
            <div class="flex-container" >
                <div class="flex-item-left br">
                    <mat-list role="list">
                        <mat-list-item role="listitem">
                            <span class="label-text">Valeur :</span>
                            <span class="text-value">{{vehicule.otherCaracteristique.vehicle_value}}</span> 
                            <mat-divider></mat-divider>
                        </mat-list-item>
                        <mat-list-item role="listitem">
                            <span class="label-text">Kilométrage :</span>
                            <span class="text-value">{{vehicule.otherCaracteristique.vehicle_mileage}}</span> 
                            
                            <mat-divider></mat-divider>
                        </mat-list-item>
                        <mat-list-item role="listitem">
                            <span class="label-text"> Energie :</span>
                            <span class="text-value">{{vehicule.otherCaracteristique.vehicle_energie}}</span>
                            <mat-divider></mat-divider>
                        </mat-list-item>
                        <mat-list-item role="listitem">
                            <span class="label-text">Boîte à vitesse :</span>
                            <span class="text-value">{{vehicule.otherCaracteristique.vehicle_gearboxe}}</span> 
    
                           
                            <mat-divider></mat-divider>
                        </mat-list-item>
                    </mat-list>
                    <mat-list role="list">
                        <mat-list-item role="listitem">
                            <span class="label-text"> Nombre de Porte(s) :</span>
                            <span class="text-value">{{vehicule.otherCaracteristique.vehicle_gearboxe}} porte(s)</span> 
                           
                            <mat-divider></mat-divider>
                        </mat-list-item>
    
                        <mat-list-item role="listitem">
                            <span class="label-text"> ABS :</span>
                            <span class="text-value">
                                <mat-icon color="primary" class="iconCkeck" *ngIf="vehicule.caracteristique?.ABS ==1">check</mat-icon>
                                <mat-icon color="warn" class="iconClose" *ngIf="vehicule.caracteristique?.ABS != 0">close</mat-icon>
                            </span>                     
                            
                            <mat-divider></mat-divider>
                        </mat-list-item>
                        
                        <mat-list-item role="listitem">
                            <span class="label-text"> EPS :</span>
                            <span class="text-value">
                                <mat-icon color="primary"class="iconCkeck" *ngIf="vehicule.caracteristique?.ESP ==1">check</mat-icon>
                                <mat-icon color="warn" class="iconClose" *ngIf="vehicule.caracteristique?.ESP != 1">close</mat-icon>
                            </span>                        
                            <mat-divider></mat-divider>
                        </mat-list-item>
                    
                        <mat-list-item role="listitem">
                            <span class="label-text"> GPS (Système de navigation) :</span>
                            <span class="text-value">
                                <mat-icon color="primary" class="iconCkeck" *ngIf="vehicule.caracteristique?.GPS ==1">check</mat-icon>
                                <mat-icon color="warn" class="iconClose" *ngIf="vehicule.caracteristique?.GPS != 1">close</mat-icon>
                            </span> 
                            
                            <mat-divider></mat-divider>
                        </mat-list-item>
    
                        <mat-list-item role="listitem">
                            <span class="label-text"> Pneus de Neige :</span>
                            <span class="text-value">
                                <mat-icon color="primary" class="iconCkeck" *ngIf="vehicule.caracteristique?.pneu_neige ==1">check</mat-icon>
                                <mat-icon color="warn" class="iconClose" *ngIf="vehicule.caracteristique?.pneu_neige != 1">close</mat-icon>
                            </span> 
                        
                            <mat-divider></mat-divider>
                        </mat-list-item>
                    </mat-list>
                </div>
                <div class="flex-item-right">
                    <mat-list role="list">
                        <mat-list-item role="listitem">
                            <span class="label-text"> Marque :</span>
                            <span class="text-value">{{vehicule.otherCaracteristique.vehicle_mark}}</span> 
                            <span class="label-text"> &nbsp;&nbsp;Model :</span>
                            <span class="text-value">{{vehicule.otherCaracteristique.vehicle_model}}</span>  
                            <mat-divider></mat-divider>
                        </mat-list-item>
    
                        <mat-list-item role="listitem">
                            <span class="label-text"> Categorie :</span>
                            <span class="text-value">{{vehicule.otherCaracteristique.vehicle_categorie}}</span>                         
                            <mat-divider></mat-divider>
                        </mat-list-item>
                    
                        
                        <mat-list-item role="listitem">
                            <span class="label-text"> Nombre de Place(s) :</span>
                            <span class="text-value">{{vehicule.otherCaracteristique.vehicle_place_number}} Place(s)</span> 
                            <mat-divider></mat-divider>
                        </mat-list-item>
    
                    </mat-list>
                    <mat-list role="list">
                       
                        <mat-list-item role="listitem">
                            <span class="label-text">Direction Assitée :</span>
                            <span class="text-value">
                                <mat-icon color="primary" class="iconCkeck" *ngIf="vehicule.caracteristique?.Direction_assiste ==1">check</mat-icon>
                                <mat-icon color="warn" class="iconClose" *ngIf="vehicule.caracteristique?.Direction_assiste != 1">close</mat-icon>
                            </span> 
                            <mat-divider></mat-divider>
                        </mat-list-item>
    
                        <mat-list-item role="listitem">
                            <span class="label-text">AirBag :</span>
                            <span class="text-value">
                                <mat-icon color="primary" class="iconCkeck" *ngIf="vehicule.caracteristique?.AirBag ==1">check</mat-icon>
                                <mat-icon color="warn" class="iconClose" *ngIf="vehicule.caracteristique?.AirBag != 1">close</mat-icon>
                            </span> 
                            
                            <mat-divider></mat-divider>
                        </mat-list-item>
    
                        <mat-list-item role="listitem">
                            <span class="label-text">Radio :</span>
                            <span class="text-value">
                                <mat-icon color="primary" class="iconCkeck" *ngIf="vehicule.caracteristique?.Radio ==1">check</mat-icon>
                                <mat-icon color="warn" class="iconClose" *ngIf="vehicule.caracteristique?.Radio != 1">close</mat-icon>
                            </span>                         
                            <mat-divider></mat-divider>
                        </mat-list-item>
    
                        <mat-list-item role="listitem">
                            <span class="label-text">Siège Enfant :</span>
                            <span class="text-value">
                                <mat-icon color="primary" class="iconCkeck" *ngIf="vehicule.caracteristique?.sieg_enfant ==1">check</mat-icon>
                                <mat-icon color="warn" class="iconClose" *ngIf="vehicule.caracteristique?.sieg_enfant != 1">close</mat-icon>
                            </span>                         
                            <mat-divider></mat-divider>
                        </mat-list-item>
    
                        <mat-list-item role="listitem">
                            <span class="label-text">Coffre de toit :</span>
                            <span class="text-value">
                                <mat-icon color="primary" class="iconCkeck" *ngIf="vehicule.caracteristique?.coffre_de_toi ==1">check</mat-icon>
                                <mat-icon color="warn" class="iconClose" *ngIf="vehicule.caracteristique?.coffre_de_toi != 1">close</mat-icon>
                            </span>                         
                            <mat-divider></mat-divider>
                        </mat-list-item>
                    </mat-list>
                    
                </div>
            </div>
        </mat-expansion-panel>
        <mat-expansion-panel style="margin-top:10px">
            <mat-expansion-panel-header>
                <mat-panel-title>
                   Reservation
                </mat-panel-title>
                <ng-template matExpansionPanelContent>
                    <div>
                        <mat-toolbar>
                            <span style="font-weight: 700;margin-right: 2px;">Montant Encaissé: </span><span> {{vehicule.reservationTotal}} XAF</span>
                        </mat-toolbar>
                        <div class="table-wrapper"> 
                            <table mat-table [dataSource]="dataSource" matSort class="w-100">            
                                <!-- Date Start Column -->
                                <ng-container matColumnDef="dateStart">
                                    <th mat-header-cell *matHeaderCellDef mat-sort-header> Date départ </th>
                                    <td mat-cell *matCellDef="let renting">{{ renting.renting_date_departure | date |titlecase}}</td>
                                </ng-container>  
                                
                                <!-- Date End Column -->
                                <ng-container matColumnDef="dateEnd">
                                    <th mat-header-cell *matHeaderCellDef mat-sort-header> Date retour </th>
                                    <td mat-cell *matCellDef="let renting">{{renting.renting_date_return| date |titlecase}}</td>
                                </ng-container>   
                    
                                <!-- Price Column -->
                                <ng-container matColumnDef="price">
                                    <th mat-header-cell *matHeaderCellDef mat-sort-header> Prix </th>
                                    <td mat-cell *matCellDef="let renting">{{renting.renting_price_location}} XOF</td>
                                </ng-container> 
                    
                                <!-- Status Column -->
                                <ng-container matColumnDef="status">
                                    <th mat-header-cell *matHeaderCellDef mat-sort-header> Statut </th>
                                    <td mat-cell *matCellDef="let renting">
                                        <span *ngIf="renting.renting_status == 'EN_ATTENTE'" style="color: blue;">En attente de validation</span>
                                        <span *ngIf="renting.renting_status == 'VALIDER'" style="color: rgb(3, 154, 3);">Valider</span>
                                        <span *ngIf="renting.renting_status == 'REJETER'" style="color:crimson;">Rejeter</span>
                                        <span *ngIf="renting.renting_status == 'ANNULER'" style="color: red;">Annuler</span>
                                        <span *ngIf="renting.renting_status == 'TERMINER'" style="color: rgb(245, 153, 68);">Terminée</span>
                                        <span *ngIf="renting.renting_status == 'PAYER'" style="color: rgb(149, 157, 42);">Location en cours</span>
                                    </td>
                                </ng-container> 
                                
                                <!-- Date Column -->
                                <ng-container matColumnDef="date">
                                    <th mat-header-cell *matHeaderCellDef mat-sort-header> Date </th>
                                    <td mat-cell *matCellDef="let renting">{{renting.created_at| date:"dd MMMM, yyyy 'a' HH:mm" }}</td>
                                </ng-container> 
                    
                                <!-- Lodger Column -->
                                <ng-container matColumnDef="lodger">
                                    <th mat-header-cell *matHeaderCellDef mat-sort-header> Locataire </th>
                                    <td mat-cell *matCellDef="let renting">{{renting.lodger_name}} {{renting.lodger_surname}}</td>
                                </ng-container> 
                        
                                <!-- Actions Column -->
                                <ng-container matColumnDef="actions">
                                    <th mat-header-cell *matHeaderCellDef> Actions </th>
                                    <td mat-cell *matCellDef="let renting">  
                                        <button *ngIf="renting.renting_status == 'EN_ATTENTE'" mat-icon-button  color="primary" matTooltip="Valider la location" (click)="changeStatus(renting.id, 'VALIDER')">
                                            <mat-icon>check</mat-icon>
                                        </button>
                                        <button *ngIf="renting.renting_status == 'EN_ATTENTE'" mat-icon-button  color="warn" matTooltip="Rejeter la location" (click)="changeStatus(renting.id, 'REJETER')">
                                            <mat-icon>clear</mat-icon>
                                        </button>
                                        
                                        <button (click)="viewRenting(renting.id)" mat-icon-button  color="accent" matTooltip="De plus détails sur la réservation">
                                            <mat-icon>visibility</mat-icon>
                                        </button>
                                        <button *ngIf="renting.renting_status == 'PAYER'" mat-icon-button  color="accent" matTooltip="faire noter la reservation" (click)="noterReservation(renting.id)">
                                            <mat-icon>speaker_notes</mat-icon>
                                        </button>
                                    </td>
                                </ng-container> 
                            
                                <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                                <tr mat-row *matRowDef="let renting; columns: displayedColumns;"></tr>
                            </table> 
                            <p *ngIf="dataSource && dataSource.data.length === 0" class="py-5 mb-0 text-center">Pas de données disponibles</p> 
                        </div>
                        <mat-paginator [pageSizeOptions]="[10, 20, 30, 40, 50]"></mat-paginator>
                    </div>
                  </ng-template>
    
               
                </mat-expansion-panel-header>
        </mat-expansion-panel>
    </mat-accordion>
</div>

<ngx-spinner type="ball-clip-rotate-multiple" color="#e91e63" bdColor="rgba(51,51,51,0.8)">
    <p style="font-size: 20px; color: #e91e63; margin-top: 20px; font-weight: bold;">Loading...</p>
</ngx-spinner>
